import React from 'react';
import {Trans} from "react-i18next";
import { Link, withRouter } from 'react-router-dom';

const BackButton = ({ history, styleClass }) => {

    return (
        <div className={styleClass || 'my-3'}>
        <a  style={{ color:'#121127',marginBottom:'10px!important', cursor:"pointer", padding:'0px 0px 0px 0px'}}
            onClick={history.goBack}
          >
            <span className='pr-2 mb-3'><i className="fa fa-arrow-left ar-rotate-180" style={{color:'#72B566', fontSize:'16px'}} aria-hidden="true"></i> </span>
            <Trans>Get Back</Trans>
        </a> 
        </div>
    );
}

export default withRouter(BackButton);
